import React from 'react';
import { Box, Typography, alpha } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  CoachmarkCanvas,
  HighlightFrame,
  SkeletonBar,
} from '../../../../components/field-coachmark/CoachmarkSkeleton';
import type { CoachmarkState } from '../../../../components/field-coachmark/FieldCoachmark';

const StepHeader = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
    <SkeletonBar width={104} height={7} />
    <SkeletonBar width={62} height={5} />
  </Box>
);

const StepFooter = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.75 }}>
    <Box
      sx={theme => ({
        width: 150,
        height: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 6px',
        borderRadius: '4px',
        border: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Typography sx={{ fontSize: 9, color: 'text.primary' }}>CID</Typography>
      <SkeletonBar width={6} height={4} />
    </Box>
    <SkeletonBar width={54} height={12} sx={{ borderRadius: '6px' }} />
  </Box>
);

const MessageVisiblePreview = () => (
  <CoachmarkCanvas sx={{ alignItems: 'center' }}>
    <StepHeader />
    <HighlightFrame sx={{ borderRadius: '12px', padding: '6px 8px', alignItems: 'flex-start' }}>
      <Box
        sx={theme => ({
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          width: 148,
          padding: '5px 7px',
          borderRadius: '10px',
          backgroundColor: alpha(theme.palette.info.main, 0.14),
        })}
      >
        <InfoOutlinedIcon sx={{ fontSize: 13, color: 'info.main', flexShrink: 0 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4, flex: 1 }}>
          <SkeletonBar height={4} />
          <SkeletonBar height={4} />
          <SkeletonBar width="70%" height={4} />
        </Box>
      </Box>
    </HighlightFrame>
    <StepFooter />
  </CoachmarkCanvas>
);

const MessageHiddenPreview = () => (
  <CoachmarkCanvas sx={{ alignItems: 'center' }}>
    <StepHeader />
    <Box
      sx={theme => ({
        width: 166,
        height: 46,
        borderRadius: '12px',
        border: `2px dashed ${theme.palette.divider}`,
      })}
    />
    <StepFooter />
  </CoachmarkCanvas>
);

export const showCidMessageStates: CoachmarkState[] = [
  { label: 'Marcado', preview: <MessageVisiblePreview /> },
  { label: 'Desmarcado', preview: <MessageHiddenPreview /> },
];
